var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.taskDescription))]),_c('div',{staticClass:"spinner",class:{idle: _vm.idle}},_vm._l((6),function(i){return _c('div',{key:i})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }